module.exports = __webpack_public_path__ + "static/media/no-result.ac3bbd14.png";